webpackJsonp([17003751226190],{

/***/ 1221:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"htmlAst":{"type":"root","children":[{"type":"element","tagName":"h2","properties":{},"children":[{"type":"text","value":"Uitleg"}]},{"type":"text","value":"\n"},{"type":"element","tagName":"p","properties":{},"children":[{"type":"text","value":"De vormen van het "},{"type":"element","tagName":"a","properties":{"href":"/spqr/rijtjes/vragend-voornaamwoord"},"children":[{"type":"text","value":"bijvoeglijk vragend voornaamwoord"}]},{"type":"text","value":" moet je uit je hoofd leren, ze zijn vrij onregelmatig."}]}],"data":{"quirksMode":false}},"frontmatter":{"book":"spqr","leerdoel":"22e","title":"Leerdoel 22e"}}},"pathContext":{"slug":"/spqr/leerdoelen/22e/","title":"Leerdoel 22e"}}

/***/ })

});


// WEBPACK FOOTER //
// path---spqr-leerdoelen-22-e-a9aab9236b34e6280cf9.js